<template>
	<div class="tooltip">
		<span v-if="text" class="tooltip-text">{{ text }}</span>

		<slot />
	</div>
</template>

<script>
export default {
	name: 'Tooltip',
	props: {
		text: {
			type: String,
			default: ''
		}
	}
}
</script>

<style lang="scss">
	.tooltip {
		position: relative;
		display: inline-block;

		&:hover .tooltip-text {
			visibility: visible;
			opacity: 1;
		}

		.tooltip-text {
			visibility: hidden;
			width: 140px;
			box-shadow: inset 3px 1px 11px 0 rgba(0, 0, 0, 0.5);
			background-color: rgba(33, 33, 33, 0.9);
			color: $white;
			text-align: center;
			font-size: 12px;
			border-radius: 6px;
			padding: 5px;
			position: absolute;
			z-index: 1;
			bottom: 125%;
			left: 62%;
			margin-left: -75px;
			opacity: 0;
			transition: opacity 0.3s;

			@include respond-below(phone) {
				width: 80px;
				margin-left: -40px;
			}

			&::after {
				content: "";
				position: absolute;
				top: 100%;
				left: 50%;
				margin-left: -5px;
				border-width: 5px;
				border-style: solid;
				border-color: rgba(33, 33, 33, 0.9) transparent transparent transparent;
			}
		}
	}
</style>
